export default "__VITE_ASSET__DXZZaN$e__"